<div class="row" style="margin-top:65px">
  <h4><i class="fas fa-fw fa-envelope me-2"></i>Secure Message Center</h4>
</div>
<div class="row">
  <div class="col-12 col-md-3 col-lg-2">
      <nav class="py-3">
        <button class="btn btn-dark mb-2 w-100" data-bs-toggle="modal" data-bs-target="#composeModal" (click)="loadComposer()">
          <i class="fas fa-fw fa-pen me-2"></i>Compose
        </button>
        <ul class="nav nav-pills flex-column mb-auto" id="smc_folders">
          <li>
            <a id="lnk_inbox" (click)="toggleFolder('inbox')" class="nav-link nav-link-active text-dark pointer"><i class="fas fa-fw fa-inbox me-2"></i>Inbox<span class="badge rounded-pill float-end mt-1 bg_boneshadow c_black">{{countNew}}</span></a>
          </li>
          <li>
            <a id="lnk_sent" (click)="toggleFolder('sent')" class="nav-link text-dark pointer"><i class="fas fa-fw fa-play me-2"></i>Sent<span class="badge rounded-pill float-end mt-1 bg_boneshadow c_black">{{countSent}}</span></a>
          </li>
          <li>
            <a id="lnk_drafts" (click)="toggleFolder('drafts')" class="nav-link text-dark pointer"><i class="fas fa-fw fa-pen-to-square me-2"></i> Drafts<span class="badge rounded-pill float-end mt-1 bg_boneshadow c_black">{{countDraft}}</span></a>
          </li>
          <li>
            <a id="lnk_trash" (click)="toggleFolder('trash')" class="nav-link text-dark pointer"><i class="fas fa-fw fa-trash me-2"></i>Trash<span class="badge rounded-pill float-end mt-1 bg_boneshadow c_black d-none">{{countTrash}}</span></a>
          </li>
        </ul>
      </nav>
  </div>
  <div class="col-12 col-md-3 col-lg-4">
    <main class="email-list bg-white">
      <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
        <h6 class="mb-0 fw-bold"><i class="fas fa-fw fa-{{currentIcon}} me-2"></i>{{currentFolder}}</h6>
      </div>
      <div class="list-group list-group-flush">
        <div *ngFor="let msg of folderCurrent" id="msg_{{msg.id}}" class="list-group-item px-3 py-2" (click)="loadMessage(msg.id)">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1 fw-bold">{{msg.sender_name}}</h6>
            <small>{{formatDate(msg.msg_date)}}</small>
          </div>
          <p class="mb-1 text-truncate small fw-bold">{{msg.msg_subject}}</p>
          <!--<small class="text-muted text-truncate d-block">Hi team, I've attached the latest report for your review...</small>-->
        </div>
        <!--<div class="list-group-item p-3">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">GitHub</h6>
            <small>Yesterday</small>
          </div>
          <p class="mb-1 text-truncate small">[Security] Alert for your repository</p>-->
          <!--<small class="text-muted text-truncate d-block">We found a vulnerability in one of your dependencies...</small>-->
        <!--</div>-->
      </div>
    </main>
  </div>
  <div class="col-12 col-md-6">
    <section class="email-content flex-grow-1 p-2" *ngIf="msgID > 0">
      <div class="d-flex border-bottom pb-3 mb-4">
        <div>
          <h3>{{msgSubject}}</h3>
          <div class="d-flex align-items-center mt-3">
            <div class="bg_sand text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 45px; height: 45px;">{{msgSenderInitials}}</div>
            <div>
              <p class="mb-0 fw-bold">{{msgSenderName}}
              <span class="text-muted fw-normal">&lt;{{msgSenderEmail}}&gt;</span>
              </p>
              <small class="text-muted">To: {{msgRecipName}} &lt;{{msgRecipEmail}}&gt;</small>
            </div>
          </div>
        </div>
      </div>

      <article [innerHTML]="msgBody">
        
      </article>

      <div class="mt-5 p-3 bg-light border rounded" *ngIf="">
        <div>
          <i class="bi bi-paperclip"></i> <a href="#" class="text-decoration-none">Q3_Report_Final.pdf</a> (2.4 MB)
        </div>
      </div>
    </section>
  </div>
</div>

<div class="modal fade" id="composeModal" tabindex="-1" aria-labelledby="composeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content shadow-lg">
      <div class="modal-header bg-dark">
        <h5 class="modal-title c_black" id="composeModalLabel"><i class="fas fa-fw fa-pen me-2"></i>Compose Message</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body p-0">
        <div class="py-2 text-center c_{{errorMsgColor}} bolder" *ngIf="errorMsg != ''">
          <i class="fas fa-fw fa-exclamation-triangle me-2"></i>{{errorMsg}}
        </div>
        <div class="px-3 py-2 border-bottom">
          <ng-multiselect-dropdown [placeholder]="'Select Sender'"
                                   [settings]="ddSettingsSender"
                                   [data]="listUsers"
                                   [(ngModel)]="composerSender"
                                   (onSelect)="onSenderSelect($event)"
                                   [disabled]="userRole == 1">
          </ng-multiselect-dropdown>
        </div>
        <div class="px-3 py-2 border-bottom">
          <ng-multiselect-dropdown [placeholder]="'Select Recipient(s)'"
                                   [settings]="ddSettingsUser"
                                   [data]="listUsers"
                                   [(ngModel)]="composerRecipients"
                                   (onSelect)="onRecipientSelect($event)"
                                   #dropdownUsers
                                   >
          </ng-multiselect-dropdown>
        </div>
        <div class="px-3 py-2 border-bottom">
          <input id="composerSubject" type="text" [(ngModel)]="composerSubject" class="form-control border-0 shadow-none" placeholder="Subject" autocomplete="off">
        </div>
        <div class="px-3 py-2">
          <editor apiKey="{{tinyMCEKey}}"
                  [init]="config"
                  [(ngModel)]="composerMessage"
                  >
          </editor>
        </div>
        <div class="px-3 py-2">
          <label for="up_file" class="w600 my-1"><i class="fas fa-fw fa-paperclip me-2"></i>Add Attachments</label>
          <input class="form-control form-control-sm" type="file" id="up_file"
                 [(ngModel)]="uploadFiles"
                 (change)="populateList($event)"
                 multiple
                 accept=".jpg, .jpeg, image/png, application/pdf"
                 />
          <div id="upload_list" [innerHTML]="uploadDetail" class="my-2"></div>
        </div>
      </div>

      <div class="modal-footer text-end">
            <button type="button" class="btn btn-link text-decoration-none text-dark border" data-bs-dismiss="modal"><i class="fas fa-fw fa-times me-2"></i>Discard</button>
            <button type="button" class="btn btn-link text-decoration-none text-dark border mx-2" (click)="saveMessage()"><i class="fas fa-fw fa-save me-2"></i>Save Draft</button>
            <button type="button" class="btn btn-dark px-4" (click)="sendMessage()"><i class="fas fa-fw fa-paper-plane me-2"></i>Send</button>
      </div>
    </div>
  </div>
</div>
